import axios from 'axios'
import { getUserToken } from 'services/utils'

export default {
  update: (data) => (
    axios.put(`${getUserToken().type}/${getUserToken().id}/profile`, data)
  ),
  change_pwd: (data) => (
    axios.put(`${getUserToken().type}/${getUserToken().id}/change-pwd`, data)
  ),
  change_iban: (data) => (
    axios.put(`${getUserToken().type}/${getUserToken().id}/change-iban`, data)
  ),
  get_curr: () => (
    axios.get(`${getUserToken().type}/${getUserToken().id}`)
  )
}


// WEBPACK FOOTER //
// ./src/api/user.js